// Placeholder utilities - to be implemented
export const validateEmail = (email: string): boolean => {
  // RFC 5322 compliant email validation - allows +, -, ., _, and other valid characters
  // Local part: allows letters, numbers, and special characters: ! # $ % & ' * + - / = ? ^ _ ` { | } ~
  // Domain part: allows letters, numbers, dots, and hyphens
  const emailRegex = /^[a-zA-Z0-9.!#$%&'*+\-/=?^_`{|}~]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
  return emailRegex.test(email);
};

export const validatePassword = (password: string): boolean => {
  return password.length >= 6; // MVP requirement: minimum 6 characters
};

export const validateUsername = (username: string): boolean => {
  return username.length >= 3 && username.length <= 20;
};

export const validateSessionId = (sessionId: string): boolean => {
  return sessionId.length > 0;
};

export const validatePlayerId = (playerId: string): boolean => {
  return playerId.length > 0;
};
